import { useEffect } from 'react';

import useScanCountersStore from '../stores/scanCountersStore';

/** Counters for the current org. `enabled=false` (no permission) fetches nothing. */
export default function useScanCounters(enabled = true) {
  const hipId = useScanCountersStore((s) => s.hipId);
  const counters = useScanCountersStore((s) => s.counters);
  const loaded = useScanCountersStore((s) => s.loaded);
  const failed = useScanCountersStore((s) => s.failed);
  const fetchCounters = useScanCountersStore((s) => s.fetchCounters);

  useEffect(() => {
    if (enabled) fetchCounters();
  }, [enabled, fetchCounters]);

  return { hipId, counters, loaded, failed, retry: () => fetchCounters({ force: true }) };
}
